/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
// nodejs library to set properties for components
import React, { useState } from "react";
import Avatar from "react-avatar";
import { useQueryClient } from "react-query";
import { Link, NavLink as NavLinkRRD, useHistory } from "react-router-dom";
// reactstrap components
import {
  Col, Collapse, Container, DropdownItem, DropdownMenu, DropdownToggle, Media, Nav, Navbar, NavItem,
  NavLink, Row, UncontrolledDropdown
} from "reactstrap";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { RouteItem } from "../../types";

const Sidebar: React.FC<{
  routes: RouteItem[];
  // logo: {
  //   innerLink?: string;
  //   outerLink?: string;
  //   imgAlt?: string;
  //   imgSrc: string;
  // };
}> = (props) => {
  const { data } = useCurrentUser()
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [earningsDropdownOpen, setEarningsDropdownOpen] = useState(false);
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const toggleEarningsDropdown = () => {
    setEarningsDropdownOpen((prev) => !prev);
  };

  const createLinks = (routes: RouteItem[]) => {
    return routes.map((prop, key) => {
      // console.log('prop', prop);
      if (prop.name === "Earnings Call") return null;
      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
            activeClassName="active"
          >
            <i className={prop.icon} />
            {prop.name}
          </NavLink>
        </NavItem>
      );
    });
  };

  const handleExportToExcel = () => {
    const token = localStorage.getItem('token')
    window.open(`${process.env.REACT_APP_API_BASE_URL}/projects/exportToExcel?token=${token}`)
  }
  const { routes } = props;

  const queryClient = useQueryClient()
  const router = useHistory()
  const handleLogout = () => {
    localStorage.removeItem('token')
    router.replace('/auth/login')
    queryClient.clear()
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        <div className="text-center mb-0 pt-2 h3">ViSense</div>
        <div>
          <img src="/dir.jpg" alt="logo" width="100%" />
        </div>
        {/* User */}
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav className="nav-link-icon">
              <i className="ni ni-bell-55" />
            </DropdownToggle>
            <DropdownMenu
              aria-labelledby="navbar-default_dropdown_1"
              className="dropdown-menu-arrow"
              right
            >
              <DropdownItem>Action</DropdownItem>
              <DropdownItem>Another action</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Something else here</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <Avatar name={data?.name} size="36" className="avatar rounded-circle" />
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>My profile</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-settings-gear-65" />
                <span>Settings</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={handleLogout}>
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              <Col className="collapse-brand" xs="6">
                <div className="text-dark mb-0">ViSense</div>
              </Col>
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Form */}
          {/* <Form className="mt-4 mb-3 d-md-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search for a project"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form> */}
          {/* Navigation */}
          <Nav navbar>
            {createLinks(routes)}

            {/* <NavItem style={{ cursor: 'pointer' }}>
              <NavLink
                onClick={handleExportToExcel}
              >
                <i className="ni ni-cloud-download-95 text-primary" />
                {' '}Export Excel
              </NavLink>
            </NavItem> */}

            <UncontrolledDropdown nav inNavbar isOpen={earningsDropdownOpen} toggle={toggleEarningsDropdown}>
              <DropdownToggle nav >
                <i className="fas fa-chart-line text-primary" /> Earnings Call
                <i className={`ni ${earningsDropdownOpen ? 'ni-bold-up' : 'ni-bold-down'} ml-2`} />
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  to="/admin/earningsCall/transcriptsList"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                  activeClassName="active"
                >
                  <i className="fas fa-list text-primary" />
                  Transcripts List
                </DropdownItem>
                <DropdownItem
                  to="/admin/earningsCall/historicalAnalysis"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                  activeClassName="active"
                >
                  <i className="fas fa-history text-primary" />
                  Historical Analysis
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Sidebar;
